module.exports = __webpack_public_path__ + "static/img/ninja-can-16.1766aaef.png";